<template>
  <div>
    <!-- <div class="row topmainrow">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <div class="topmainlayer card">
          <div class="mainCircle">
            <div class="circlem">
              <div class="circleText circleText1"><p>사고<br>Zero</p></div>
              <div class="circleTextCenter">- 기본을 준수하는 안전문화 구축<br>- 중대재해 예방 관리</div>
            </div>
            <div class="circlem">
              <div class="circleText circleText2"><p>시스템<br>구축</p></div>
              <div class="circleTextCenter">- 법규/규정 준수 및 자율 실천<br>- 지속적 안전보건 개선 활동 추구</div>
            </div>
            <div class="circlem">
              <div class="circleText circleText3"><p>녹색<br>경영</p></div>
              <div class="circleTextCenter">- 환경 오염 최소화 및 자원의 재활용 촉진<br>- ESG경영 실천 및 목표 달성</div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="card cardcontents">
              <div class="card-header">
                개선
                <div class="card-more card-more-txt" @click="goPage('/sop/ibm/impr')">상세보기</div>
              </div>
              <div class="card-body">
                <c-table
                  ref="impr1"
                  tableId="impr1"
                  :isTitle="false"
                  :isDashboard="true"
                  :columnSetting="false"
                  :usePaging="false"
                  :filtering="false"
                  :isFullScreen="false"
                  :hideBottom="true"
                  gridHeight="191px"
                  :columns="impr1.columns"
                  :data="impr1.data"
                  @rowClick="rowClick2"
                >
                  <template v-slot:customArea="{ props }">
                    <template v-if="props.row['typeName']">
                      <q-chip
                        :color="setImprColor(props.row.typeName)"
                        :clickable="false"
                        class="mainImprState"
                        text-color="white">
                        {{props.row.typeName}}
                      </q-chip>
                    </template>
                  </template>
                </c-table>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="card cardcontents">
              <div class="card-header">
                최신 법제처 법령
                <div class="card-more card-more-txt" @click="goPage('/chm/law/safetyControlDangerous')">상세보기</div>
              </div>
              <div class="card-body">
                <c-table
                  ref="safety"
                  tableId="safety"
                  :isTitle="false"
                  :isDashboard="true"
                  :columnSetting="false"
                  :usePaging="false"
                  :filtering="false"
                  :isFullScreen="false"
                  :hideBottom="true"
                  gridHeight="209px"
                  :columns="safety.columns"
                  :data="safety.data"
                >
                  <template v-slot:customArea="{ props, col }">
                    <template v-if="props.row.lawLink">
                      <q-btn
                        class="tableinnerBtn"
                        flat
                        icon="launch"
                        align="center"
                        color="blue-6"
                        label=""
                        @click.stop="lawLinkClick(props, col)" />
                    </template>
                  </template>
                </c-table>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="card cardcontents">
              <div class="card-header">
                부서별 사고건수 그래프 (소속사업장)
                <!-- <div class="card-more" @click="goPage('/sop/iim/processAccident')">more</div> -->
                <div class="card-more main-header-input" style="width:140px;">
                  <c-datepicker
                    name="workPermitDate"
                    type="year"
                    v-model="accident.year"
                    @datachange="getDeptAccList"
                  />
                </div>
              </div>
              <div class="card-body"> 
                <apexchart 
                  ref="yearOcuurChart" 
                  height="326" 
                  type="bar"
                  :options="yearOcuurChart.chartOptions" 
                  :series="yearOcuurChart.series"></apexchart>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="card cardcontents">
              <div class="card-header">
                개선조치목록
                <div class="card-more" @click="goPage('/sop/ibm/impr')">more</div>
              </div>
              <div class="card-body">
                <c-table
                  ref="impr2"
                  tableId="impr2"
                  :isTitle="false"
                  :isDashboard="true"
                  :columnSetting="false"
                  :usePaging="false"
                  :filtering="false"
                  :isFullScreen="false"
                  :hideBottom="true"
                  gridHeight="150px"
                  :columns="impr2.columns"
                  :data="impr2.data"
                  @rowClick="rowClick2"
                >
                </c-table>
              </div>
            </div>
          </div>
        </div> -->
      </div>
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
        <div class="card cardcontents">
          <div class="card-header">
            작업허가서 MAP
            <div class="card-more card-more-txt" @click="goPage('/sop/swp/safeWorkPermit')">상세보기</div>
            <div class="card-more main-header-input" style="width:140px;">
              <c-datepicker
                name="workPermitDate"
                default="today"
                v-model="workPermit.date"
                @datachange="getWorkPermit"
              />
            </div>
            <div class="card-more main-header-input">
              <c-select
                v-if="workPermit.maps && workPermit.maps.length > 0"
                :comboItems="workPermit.maps"
                type="none"
                itemText="mapName"
                itemValue="sopMapId"
                name="sopMapId"
                label=""
                v-model="workPermit.sopMapId"
                @datachange="mapChange"
              ></c-select>
            </div>
          </div>
          <div class="card-body">
            <q-carousel
              v-if="workPermit.maps && workPermit.maps.length > 0"
              class="workPermit-carousel"
              swipeable
              animated
              arrows
              control-type="regular"
              control-color="orange"
              v-model="workPermit.slide"
              infinite
            >
              <q-carousel-slide 
                v-for="(map, idx) in workPermit.maps"
                :key="idx"
                :name="idx" 
                :img-src="map.mapSrc">
                <template>
                  <VueDraggableResizable
                    v-for="(item, idx) in map.maps"
                    :key="idx"
                    ref="markImage"
                    class="mainMarkImage"
                    :resizable="false"
                    :parent="true"
                    :draggable="false"
                    :x="item.locationXcoordinate"
                    :y="item.locationYcoordinate"
                    :w="30" :h="20"
                    :grid="[30, 20]"
                  >
                    <!-- {{idx + 1}} -->
                    <q-icon name="push_pin" class="blinking" />
                    <div class="markImage-abbreviation-parent"
                      :style="{ 
                        width: !item.isHover 
                          ? item.resultTypes.length > 3 ? '227px' : getWidth(item)
                          : '241px', 
                        left: getLeft(item),
                        top: getTop(item),
                      }">
                      <div class="markImage-abbreviation" 
                        @mouseover="() => { item.isHover = true }"
                        @mouseleave="() => { item.isHover = false }">
                        <transition name="mark-list" tag="div">
                          <div v-if="!item.isHover" class="markImage-tran">
                            <q-banner v-for="(resultType, idx) in item.resultTypes.slice(0, 3)"
                              :key="idx"
                              dense 
                              :class="[
                                'markImage-abbreviation-banner',
                                item.resultTypes.length < 4 && idx === item.resultTypes.length - 1 ? 'last-banner' : ''
                              ]">
                              <q-icon :name="workPermitIconName(resultType)" class="text-red" />
                              <div>
                                {{resultType.sopWorkTypeName}}
                              </div>
                            </q-banner>
                            <q-banner v-if="item.resultTypes.length > 3"
                              key="-1"
                              dense 
                              :class="['markImage-abbreviation-plus']">
                              <q-icon name="add" class="text-red" />{{item.resultTypes.length - 3}}
                              <div>
                                <q-icon name="more_horiz" class="text-black" />
                              </div>
                            </q-banner>
                          </div>
                        </transition>
                        <transition name="mark-list" tag="div">
                          <div v-show="item.isHover">
                            <q-banner v-for="(resultType, idx) in item.resultTypes"
                              :key="idx"
                              dense 
                              :class="[idx % 2 ===1 ? 'bg-grey-3' : 'bg-grey-1', 'markImage-abbreviation-banner-detail']">
                              <template v-slot:avatar>
                                <q-icon :name="workPermitIconName(resultType)" class="text-red" />
                              </template>
                              {{resultType.sopWorkTypeName}}
                              <q-badge :color="workPermitbadgeColor(resultType.swpStepName)" :label="resultType.swpStepName" />
                              <q-btn class="q-ml-sm" outline round dense color="red" size="9px" label="" icon="add" @click="openWorkPermit(resultType)" />
                              <div class="caption-work">
                                {{resultType.workSummary}}
                              </div>
                            </q-banner>
                          </div>
                        </transition>
                      </div>
                    </div>
                  </VueDraggableResizable>
                </template>
              </q-carousel-slide>
            </q-carousel>
            <el-empty v-else 
              :image-size="467"
              description="지도에 등록된 작업허가서가 없습니다."></el-empty>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
          <div class="card cardcontents">
            <div class="card-header">
              공지사항
              <div class="card-more card-more-txt" @click="goPage('/sys/notice/noticeManage')">상세보기</div>
            </div>
            <div class="card-body">
              <c-table
                ref="table6"
                tableId="table6"
                :isTitle="false"
                :isDashboard="true"
                :columnSetting="false"
                :usePaging="false"
                :filtering="false"
                :isFullScreen="false"
                :hideBottom="true"
                gridHeight="191px"
                :columns="grid6.columns"
                :data="grid6.data"
                @rowClick="rowClick6"
              >
              </c-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <component
          :is="impr.component"
        />
      </div>
    </div>
    <q-dialog v-model="noticedialog" position="top">
      <q-card style="min-width: 800px;width: 800px">
        <q-card-section class="row items-center no-wrap mainpoplayer">
          <q-list bordered class="rounded-borders" style="width: 100%">
            <q-expansion-item v-for="tag in popNotices"
              switch-toggle-side
              :key="tag.sysNoticeId"
              group="noticepops"
              header-class="bg-orange-7 text-white"
              style="border-bottom: 1px solid #fff;"
              expand-icon-class="text-white"
              :id="tag.sysNoticeId"
              v-model="tag.expanded">
              <template v-slot:header>
                <q-item-section>
                  {{tag.noticeTitle}}
                </q-item-section>
                <q-item-section avatar>
                  <q-icon color="white" name="close"  @click="closePopNotice(tag.sysNoticeId)"/>
                </q-item-section>
              </template>
              <q-card>
                <q-card-section>
                  <div v-html="tag.noticeContents"/>
                </q-card-section>
                <q-card-section v-if="tag.cnt > 0">
                  <c-upload
                    :attachInfo="{taskClassCd: 'NOTICE_ATTACH', taskKey: tag.sysNoticeId}"
                    :editable="false"
                    label="첨부파일">
                  </c-upload>
                </q-card-section>
              </q-card>
              <q-card v-show="tag.dayViewDisable">
                <q-card-section>
                  <q-toggle
                    size="sm"
                    class="anymoreNotice"
                    v-model="tag.dayView"
                    checked-icon="check"
                    color="red"
                    label="더이상 보지 않기"
                    unchecked-icon="clear"
                    @input="updateTodayChk(tag.sysNoticeId)"
                  />
                </q-card-section>
              </q-card>
            </q-expansion-item>
          </q-list>
        </q-card-section>
      </q-card>
    </q-dialog>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import VueDraggableResizable from 'vue-draggable-resizable'
import VueApexCharts from "vue-apexcharts";
import selectConfig from '@/js/selectConfig';
export default {
  name: 'main-dashboard',
  components: { VueDraggableResizable,
  apexchart: VueApexCharts
  },
  props: {
  },
  data() {
    return {
      attachInfo: {
        isSubmit: '',
        taskClassCd: 'NOTICE_ATTACH',
        taskKey: '',
      },
      noticedialog: false,
      workPermit: {
        sopMapId: null,
        slide: 0,
        date: '',
        listUrl: '',
        mapSrc: require('@/assets/images/no-image.png'),
        maps: [],
      },
      accident: {
        year: '',
      },
      isHover: false,
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
      noticePopUrl: '',
      popNotices: [],
      popRealNotices: 0,
      safetyUrl: '',
      grid3: {
        columns: [
          {
            name: 'workSummary',
            field: 'workSummary',
            label: '작업개요',
            align: 'left',
            style: 'width:250px',
            sortable: false,
          },
          {
            name: 'permitTypeName',
            field: 'permitTypeName',
            label: '허가서구분',
            align: 'center',
            sortable: false,
            style: 'width:100px',
          },
          {
            name: 'applicationDeptName',
            field: 'applicationDeptName',
            label: '신청부서',
            align: 'center',
            sortable: false,
            style: 'width:100px',
          },
        ],
        data: [],
      },
      grid6: {
        listUrl: '',
        columns: [
          {
            name: 'noticeClassName',
            field: 'noticeClassName',
            label: '공지분류',
            align: 'center',
            style: 'width: 100px',
            sortable: false,
          },
          {
            name: 'noticeTitle',
            field: 'noticeTitle',
            label: '제목',
            align: 'left',
            sortable: false,
          },
        ],
        data: [],
      },
      impr1: {
        listUrl: '',
        columns: [
          {
            name: 'ibmTaskTypeName',
            field: 'ibmTaskTypeName',
            label: '구분',
            align: 'center',
            style: 'width: 80px',
            sortable: false,
          },
          {
            name: 'typeName',
            field: 'typeName',
            label: '요청/조치',
            align: 'center',
            style: 'width: 80px',
            type: 'custom',
            sortable: false,
          },
          {
            name: 'deptName',
            field: 'deptName',
            label: '조치/요청부서명',
            align: 'center',
            style: 'width: 100px',
            sortable: false,
          },
          {
            name: 'ibmTitle',
            field: 'ibmTitle',
            label: '요청명',
            align: 'left',
            style: 'width: 250px',
            sortable: false,
          },
          {
            name: 'ibmStepName',
            field: 'ibmStepName',
            label: '상태',
            style: 'width: 80px',
            align: 'center',
            sortable: false,
          },
        ],
        data: [],
      },
      impr: {
        component: () => import(`${'./impr/imprRate.vue'}`),
      },
      yearOcuurChart: {
        chartOptions: {
          title: {
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '45%',
              distributed: true,
              endingShape: 'rounded'
            },
          },
          dataLabels: {
            enabled: true,
            formatter: function (val) {
              return val;
            },
            offsetY: 0,
            style: {
              fontSize: '12px',
              colors: ["#fcfafa"]
            }
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },
          xaxis: {
            categories: [],
          },
          yaxis: {
            title: {
              text: '건'
            }
          },
          fill: {
            opacity: 1
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return  val + " 건"
              }
            }
          }
        },
        series: [{
          name: '사고 건수',
          data: [],
        }],
        chartWidth: '80%',
      },
      safety: {
        columns: [
          {
            name: 'lawNameKor',
            field: 'lawNameKor',
            label: '법령명',
            align: 'left',
            sortable: false,
            style: 'width:220px',
          },
          {
            name: 'promulgationDate',
            field: 'promulgationDate',
            label: '공포일자',
            align: 'center',
            sortable: false,
            style: 'width:80px',
          },
          {
            name: 'revisiontypename',
            field: 'revisiontypename',
            label: '제개정구분명',
            align: 'center',
            sortable: false,
            style: 'width:80px',
          },
          {
            name: 'enforcementDate',
            field: 'enforcementDate',
            label: '시행일자',
            align: 'center',
            sortable: false,
            style: 'width:80px',
          },
          {
            name: 'custom',
            field: 'custom',
            label: '법령상세링크',
            align: 'center',
            sortable: false,
            style: 'width:80px',
            type: 'custom'
          },
        ],
        data: [],
      }
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // url setting
      this.workPermit.listUrl = selectConfig.main.workPermit.url
      this.grid6.listUrl = selectConfig.sys.notice.list.url;
      this.noticePopUrl = selectConfig.sys.notice.main.url;
      this.impr1.listUrl = selectConfig.main.imprRequest.url;
      this.deptAccUrl = selectConfig.sop.iim.accident.status.year.dept.url;
      this.safetyUrl = selectConfig.main.law.url;

      this.accident.year = this.$comm.getThisYear();
      // list setting
      this.getWorkPermits();
      this.getWorkPermit();
      this.getNotice();
      this.getNoticePop();
      this.getImprRequest();
      this.getDeptAccList();
      this.getSafetyList();
    },
    getWorkPermits() {
      this.$http.url = selectConfig.sop.swp.workPermit.list.url
      this.$http.type = 'GET';
      this.$http.param = {
        permitDates: [this.$comm.getToday(), this.$comm.getToday()],
        plantCd: this.$store.getters.user.plantCd,
      }
      this.$http.request((_result) => {
        this.grid3.data = _result.data;
      },);
    },
    getSafetyList() {
      this.$http.url = this.safetyUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.safety.data = _result.data;
      },);
    },
    getDeptAccList() {
      this.$http.url = this.deptAccUrl;
      this.$http.type = 'GET';
      this.$http.param = {
        year: this.accident.year,
        plantCd: this.$store.getters.user.plantCd,
      };
      this.$http.request((_result) => {
        this.yearOcuurChart.series[0].data = [];
        this.yearOcuurChart.chartOptions.xaxis.categories = [];

        this.$_.forEach(_result.data, _item => {
        // 년도에 따른 idx를 구하여 series.data의 위치 통일
          this.yearOcuurChart.chartOptions.xaxis.categories.push(_item.deptName)
          this.yearOcuurChart.series[0].data.push(_item.yearDeptCount)
        })
        
        this.yearOcuurChart.chartWidth = '80%';
        this.$refs['yearOcuurChart'].refresh();
      },);
    },
    getWorkPermit() {
      let defaultPlantCd = window.sessionStorage.getItem('defaultPlantCd');
      this.$http.url = this.workPermit.listUrl;
      this.$http.type = 'GET';
      this.$http.param = {
        plantCd: defaultPlantCd,
        date: this.workPermit.date
      }
      this.$http.request((_result) => {
        this.workPermit.maps = _result.data;
        this.$_.forEach(this.workPermit.maps, map => {
          this.$_.forEach(map.maps, item => {
            this.$set(item, 'isHover', false)
          });
        })
        if (this.workPermit.maps && this.workPermit.maps.length > 0) {
          this.$set(this.workPermit, 'sopMapId', this.workPermit.maps[0].sopMapId)
        }
      },);
    },
    mapChange(data) {
      let idx = this.$_.findIndex(this.workPermit.maps, { sopMapId: data.value });
      if (idx > -1) {
        this.$set(this.workPermit, 'slide', idx)
      } else {
        this.$set(this.workPermit, 'slide', 0)
      }
    },
    workPermitIconName(resultType) {
      let icon = '';
      switch(resultType.sopWorkTypeCd) {
        case 'SPT0000001': // 일반
          icon = 'engineering';
          break;
        case 'SPT0000005': // 화기
          icon = 'local_fire_department';
          break;
        case 'SSWT000001': // 밀폐공간
          icon = 'dangerous';
          break;
        case 'SSWT000005': // 정전
          icon = 'flash_off';
          break;
        case 'SSWT000010': // 방사선
          icon = 'warning';
          break;
        case 'SSWT000015': // 굴착
          icon = 'hardware';
          break;
        case 'SSWT000020': // 고소
          icon = 'stairs';
          break;
        case 'SSWT000025': // 중장비
          icon = 'agriculture';
          break;
      }
      return icon;
    },
    workPermitbadgeColor(swpStepName) {
      let icon = '';
      switch(swpStepName) {
        case '승인완료':
          icon = 'light-blue';
          break;
        case '연장':
          icon = 'amber';
          break;
        case '작업완료':
          icon = 'light-green';
          break;
      }
      return icon;
    },
    openWorkPermit(item) {
      if (!item) return;
      this.popupOptions.isFull = true;
      this.popupOptions.title = '작업허가서';
      this.popupOptions.param = {
        sopWorkPermitId: item.sopWorkPermitId,
        permitTypeCd: item.sopWorkTypeCd,
      };
      this.popupOptions.target = () => import(`${'@/pages/sop/swp/safeWorkPermitDetail.vue'}`);
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeWorkPermitPopup;
    },
    closeWorkPermitPopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
    },
    getNotice() {
      this.$http.url = this.grid6.listUrl;
      this.$http.type = 'GET';
      this.$http.param = {
        vendorFlag: 'N',
        pagelimit: 5,
      }
      this.$http.request((_result) => {
        this.grid6.data = _result.data;
      },);
    },
    getNoticePop() {
      this.popNotices = [];
      this.popRealNotices = 0;
      this.$http.url = this.noticePopUrl;
      this.$http.type = 'GET';
      this.$http.param = {
        vendorFlag: 'N',
      }
      this.$http.request((_result) => {
        let mainPopNoticeId = window.localStorage.getItem('mainPopNoticeId');
        if (mainPopNoticeId !== null) {
          let icnt=0;
          this.$_.forEach(_result.data, item => {
            if (mainPopNoticeId.indexOf(item.sysNoticeId) < 0) {
              item.dayViewDisable = true;
              if (icnt == 0) {
                item.expanded = false;
              } else {
                item.expanded = false;
              }
              this.popNotices.push(item);
              this.popRealNotices++;
              icnt++;
            }
          })
          if (this.popNotices.length == _result.data.length) {
            window.localStorage.removeItem('mainPopNoticeId');
          }
        } else {
          this.popNotices = _result.data;
          let icnt=0;
          this.$_.forEach(this.popNotices, item => {
            item.dayViewDisable = true;
            if (icnt == 0) {
              item.expanded = false;
            } else {
              item.expanded = false;
            }
            this.popRealNotices++;
            icnt++;
          })
        }
        if (this.popNotices.length > 0) {
          this.noticedialog = true
        }
      },);
    },
    getNoticeDetail(_title, _content) {
      this.popNotices = [{
        sysNoticeId: '',
        expanded: true,
        dayView: false,
        noticeTitle: _title,
        noticeContents: _content,
        dayViewDisable: false,
      }];
      this.popRealNotices = 1;
      this.noticedialog = true;
    },
    updateTodayChk(_noticeId) {
      let mainPopNoticeId = window.localStorage.getItem('mainPopNoticeId');
      if (mainPopNoticeId === null) {
        window.localStorage.setItem('mainPopNoticeId', _noticeId + ',');
      } else {
        if (mainPopNoticeId.indexOf(_noticeId) < 0) {
          window.localStorage.setItem('mainPopNoticeId', mainPopNoticeId + _noticeId + ',');
        } else {
          window.localStorage.setItem('mainPopNoticeId', mainPopNoticeId.replace(_noticeId + ',',''));
        }
      }

    },
    getImprRequest() {
      this.$http.url = this.impr1.listUrl;
      this.$http.type = 'GET';
      this.$http.param = {
        plantCd: this.$store.getters.user.plantCd,
        deptCd: this.$store.getters.user.deptCd
      }
      this.$http.request((_result) => {
        this.impr1.data = _result.data;
      },);
    },
    getImprAction() {
      this.$http.url = this.impr2.listUrl;
      this.$http.type = 'GET';
      this.$http.param = {
        plantCd: this.$store.getters.user.plantCd,
        deptCd: this.$store.getters.user.deptCd
      }
      this.$http.request((_result) => {
        this.impr2.data = _result.data;
      },);
    },
    rowClick2(row) {
      this.popupOptions.title = '개선 상세'; // 개선 상세
      this.popupOptions.param = {
        sopImprovementId: row ? row.sopImprovementId : '',
      };
      this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprDetail.vue'}`);
      this.popupOptions.isFull = true;
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeImprPopup;
    },
    closeImprPopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      
      this.getImprRequest();
      // this.getImprAction();
    },
    goPage(_page) {
      this.$comm.movePage(this.$router, _page)
    },
    rowClick6(row) {
      this.getNoticeDetail(row.noticeTitle, row.noticeContents);
    },
    getWidth(item) {
      let width = 0;
      this.$_.forEach(item.resultTypes, resultType => {
        width += (resultType.sopWorkTypeName.length * 10) + 60
      })
      return width + 'px'
    },
    getLeft(item) {
      /**
       * 지도의 크기는 800
       */
      let left = 0;
      let nonDetailLocation = item.locationXcoordinate + (item.resultTypes.length * 40)
      let detailLocation = item.locationXcoordinate + 250
      let calLocation = nonDetailLocation > detailLocation ? nonDetailLocation : detailLocation
      if (calLocation > 800) {
        left = 800 - calLocation
      }
      return left + 'px'
    },
    getTop(item) {
      /**
       * 지도의 높이는 594
       */
      let top = 30;
      let calLocation = item.locationYcoordinate + (item.resultTypes.length * 76)
      if (calLocation > 594) {
        top = 594 - calLocation
      }
      return !item.isHover ? '30px' : top + 'px'
    },
    closePopNotice(_id) {
      if (_id == '') {
        this.noticedialog = false;
      } else {
        if(this.popRealNotices == 1) {
          document.getElementById(_id).remove();
          this.noticedialog = false;
        }
        if (this.popRealNotices > 1) {
          document.getElementById(_id).remove();
          this.popRealNotices = this.popRealNotices - 1;
        }
      }
    },
    /* eslint-disable no-unused-vars */
    lawLinkClick(props, col) {
      window.open('http://www.law.go.kr' + props.row.lawLink, '법규', 'width=1200, height=700');
    },
    setImprColor(_data) {
      if (_data === '조치') {
        return 'red';
      } else {
        return 'blue'
      }
    },
  }
};
</script>
<style lang="sass">
  .card-more-txt
    font-size:12px
    margin-top: 3px
  .topmainlayer
    height: 180px
    background-image: url('../../assets/images/mainback.png')
    display: block
    border-radius: 10px
    div.title
      padding: 30px 0px 0px 50px
      font-weight: 600
      color: #0070C0
      font-size: 20px
    .title1
      color: #17375E
      font-size: 25px
    .title2
      color: #17375E
      font-size: 35px
    .title3
      color: #0070C0
      font-size: 35px
    .mainbtns
      float: right !important
      margin-top: -120px
      padding-right: 20px
    .today
      color: #fb8c00
      padding-top: 35px
      padding-left: 23px
      font-weight: 600
  .mainchild
    // margin-top: -75px !important
    padding: 10px 0px 0px 0px
  .maincard
    margin-right: 6px
    margin-bottom: 6px
  // .maincard:hover
  //   margin-top: -10px
  .cardcontents
    margin-top: 6px
    margin-bottom: 6px
    margin-right: 6px
    .card-body
      padding: 10px !important
    .card-header:before
      font-family: "Material Icons"
      content: "\e876"
    .card-header
      height: 40px
      color: #00a1b9
      background: #f8f8f8
      display: inline-block
      padding-top: 8px
      .card-more
        float: right !important
        cursor: pointer
        color: #4DB6AC
  .maincard .card-body
    background: #fff
    border-radius: 5px
    padding: 15px !important
    .fw-bold
      font-weight: 600
    .material-icons
      font-size: 3em
      color: #ddd
      cursor: pointer
  .maincard .card-body.border-color-blue
    border-left: 4px solid #0061f2
  .maincard .card-body.border-color-red
    border-left: 4px solid #d92550
  .maincard .card-body.border-color-yullow
    border-left: 4px solid #f7b924
  .maincard .card-body.border-color-green
    border-left: 4px solid #3ac47d

.mainMarkImage
  padding: 0px !important
  text-align: center
  font-size: 20px
  height: 30px !important
  position: static
  padding: 16px
  color: #C10015
  // background: rgba(0,0,0,0.47)
  .markImage-abbreviation-parent
    // width:240px
    text-align: start
    position: absolute
    .markImage-abbreviation
      cursor: pointer
      display: inline-block
      // min-width:60px
      // max-width:250px
      width: auto
      border-left: 1px solid #757575
      border-right: 1px solid #757575
      border-top: 1px solid #757575
      border-bottom: 1px solid #757575
      border-radius: 5px
      .markImage-tran
        border-radius: 5px
      .markImage-abbreviation-banner
        border-right: 1px solid #757575
        display: inline-block
        text-align: center
        min-width:60px
        padding: 1px !important
        border-radius: 5px 0px 0px 5px
        i
          font-size: 20px
        div
          font-size: 12px !important
      .markImage-abbreviation-banner.last-banner
        border-right: 0
        border-radius: 0px 5px 5px 0px
      .markImage-abbreviation-plus
        display: inline-block
        text-align: center
        min-width:40px
      .markImage-abbreviation-banner-detail
        border-radius: 5px
        .q-banner__avatar i
          font-size: 20px !important
        .q-banner__content
          font-size: 12px !important
.markImage-abbreviation > div
  -webkit-animation: fadeInFromNone 0.1s ease-out
  -moz-animation: fadeInFromNone 0.1s ease-out
  -o-animation: fadeInFromNone 0.1s ease-out
  animation: fadeInFromNone 0.1s ease-out


// .mark-list-enter-active, .mark-list-leave-active
//   transition: all 0.1s
.mark-list-enter, .mark-list-leave-to
  opacity: 0
  transform: translateY(5px)

.caption-work
  font-size: 0.85em
  font-style: italic
  white-space: normal
  color: #555
  margin-top: 4px

.workPermit-carousel
  height: 630px !important
  .q-carousel__slide
    width: 800px !important
  .q-carousel--padding, .q-carousel__slide
    padding: 0 !important
  .q-carousel__arrow
    transition: all 0.5s
    opacity: 0.2
  .q-carousel__arrow:hover
    transition: all 0.5s
    opacity: 0.8
  .q-carousel__slides-container
    .q-panel.scroll
      overflow: hidden !important

.main-header-input
  margin-top: -5px
  padding-right: 5px
  .customDate
    padding-bottom: 0 !important
    .q-field__inner
      padding: 0 !important

.main-header-input2
  margin-top: -5px
  padding-right: 5px
  .customDate
    padding-bottom: 0 !important
    .q-field__inner
      padding: 0 !important
.mainpoplayer
  padding: 6px 6px 6px 6px !important
.anymoreNotice
  position: absolute
  bottom: 10px
  right: 20px
.mainCircle 
  display: flex
  justify-content: center
  padding-top: 10px
  padding-left: 10px
  .circlem
    padding-top: 10px
    width: 28%
  .circleText
    text-align: center
    border-radius: 50%
    font-size: 1.2em
    font-weight: 600
    width: 120px
    height: 120px
    position: relative
    background: #fff
    p
      padding-top: 25px
  .circleText1
    border: 8px solid #82AA35
  .circleText2
    border: 8px solid #38AD85
  .circleText3
    border: 8px solid #329FAA
  .circleTextCenter
    background: #fff
    border-radius: 5px
    margin-top: -60px
    padding-top: 20px
    margin-left: 60px
    margin-right: 10px
    padding-left: 65px
    padding-right: 10px
    font-size: 1.05em
    min-height: 83px
    border: 1px solid #ddd
.mainImprState
  height: 18px !important

@-webkit-keyframes fadeInFromNone
  0%
    opacity: 0
  50%
    opacity: 0
  70%
    opacity: 0.5
  100%
    opacity: 1

@-moz-keyframes fadeInFromNone
  0%
    opacity: 0
  50%
    opacity: 0
  70%
    opacity: 0.5
  100%
    opacity: 1

@-o-keyframes fadeInFromNone
  0%
    opacity: 0
  50%
    opacity: 0
  70%
    opacity: 0.5
  100%
    opacity: 1

@keyframes fadeInFromNone
  0%
    opacity: 0
  50%
    opacity: 0
  70%
    opacity: 0.5
  100%
    opacity: 1
</style>
<style scoped>
.widget-numbers {
  font-size: 20px;
}
.impr-item {
  height: 100% !important;
}
</style>